var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col-md-12 left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("sidebar.account")) + "\n        "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content col-md-12" },
      [
        !_vm.ready
          ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
          : [
              _c(
                "section",
                { staticClass: "col-md-12 no-padding" },
                [
                  _c("section-header", {
                    attrs: {
                      title: _vm.$t("message.cleardata"),
                      fontweight: "bold"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("message.removedatainthisstoreforall")
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.treesoft.io/th/manual/setting",
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.learnmore")) +
                              "\n              "
                          ),
                          _c("i", { staticClass: "fas fa-external-link-alt" })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          on: { click: _vm.openClearDataModal }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.cleardata")) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "col-md-12 no-padding mt-4" },
                [
                  _c("section-header", {
                    attrs: {
                      title: _vm.$t("message.deactivateaccount"),
                      fontweight: "bold"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("message.deactivateaccountdetail")) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.treesoft.io/th/manual/setting",
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.learnmore")) +
                              "\n              "
                          ),
                          _c("i", { staticClass: "fas fa-external-link-alt" })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          on: { click: _vm.openDeactivateAccountModal }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.deactivateaccount")) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "clearDataModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog ", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.areyousuretodeletethis")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  !_vm.isModalClearDataReady
                    ? _c("div", { staticClass: "col-md-12 no-padding" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.loading")) +
                            "\n          "
                        )
                      ])
                    : [
                        _vm.filterApps.length === 0
                          ? [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.settings.message.thedatacannotbeclearedatthistime"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          : [
                              _vm._l(_vm.filterApps, function(app, index) {
                                return _c("ModuleTransactionCount", {
                                  key: index,
                                  attrs: {
                                    appId: app.app_id,
                                    list: app.modules
                                  }
                                })
                              }),
                              _vm._v(" "),
                              _c("TypeToConfirmDelete", {
                                attrs: {
                                  isConfirmed: _vm.isConfirmedClearData,
                                  learnmoreLink:
                                    "https://www.treesoft.io/th/manual/setting"
                                },
                                on: {
                                  "update:isConfirmed": function($event) {
                                    _vm.isConfirmedClearData = $event
                                  },
                                  "update:is-confirmed": function($event) {
                                    _vm.isConfirmedClearData = $event
                                  }
                                }
                              })
                            ]
                      ]
                ],
                2
              ),
              _vm._v(" "),
              !_vm.isLoadingClearData
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: { click: _vm.closeClearDataModal }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.cancel")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: {
                          disabled: !_vm.isConfirmedClearData,
                          type: "button"
                        },
                        on: { click: _vm.handleDeleteShopData }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.delete")) +
                            "\n            "
                        ),
                        _c("i", { staticClass: "fas fa-exclamation-triangle" })
                      ]
                    )
                  ])
                : _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button", disabled: "" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.cancel")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "deactivateAccount",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog ", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.areyousuretodeactivateaccount"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-left": "-16px",
                      "margin-right": "-16px",
                      "margin-top": "-20px",
                      "margin-bottom": "-20px"
                    }
                  },
                  [
                    _c("TypeToConfirmDelete", {
                      attrs: {
                        isConfirmed: _vm.isConfirmedDeactivateAccount,
                        code: "confirm",
                        learnmoreLink:
                          "https://www.treesoft.io/th/manual/setting"
                      },
                      on: {
                        "update:isConfirmed": function($event) {
                          _vm.isConfirmedDeactivateAccount = $event
                        },
                        "update:is-confirmed": function($event) {
                          _vm.isConfirmedDeactivateAccount = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.isLoadingDeactivateAccount
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: { click: _vm.closeDeactivateAccountModal }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.cancel")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: {
                          disabled: !_vm.isConfirmedDeactivateAccount,
                          type: "button"
                        },
                        on: { click: _vm.handleDeactivateAccount }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.deactivateaccount")) +
                            "\n            "
                        ),
                        _c("i", { staticClass: "fas fa-exclamation-triangle" })
                      ]
                    )
                  ])
                : _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button", disabled: "" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.cancel")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", disabled: "" }
      },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", disabled: "" }
      },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37a1c3a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37a1c3a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/settings/advance/All.vue
// module id = null
// module chunks = 